import { useEffect, useState } from "react";
import { ItemState } from "../../utils/interfaces/packages";
import featuresService from "../../services/featuresService";
import {
  FeatureState,
  FeatureTypeState,
} from "../../utils/interfaces/features";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  selectFeaturesSelector,
  selectFeatureTypeSelector,
} from "../../store/features/selectors";
import { featuresActionDispatch } from "../../store/features/actions";
import { ComparisionTable } from "../../components";
import { ComparisionTableLoader } from "../../components/loaders/productLoaders";
import constants from "./constants.json";

interface ComparisionTableProps {
  bundlePackages: Array<ItemState>;
  openDialog: (id: string) => void;
  title: string;
  isSelected: string;
}

const ComparisionTableLayout = (props: ComparisionTableProps) => {
  const [loading, setLoading] = useState({ featureType: true, features: true });
  const { setFeatures, setFeatureType } =
    featuresActionDispatch(useAppDispatch());

  let { bundlePackages, openDialog, title, isSelected } = props;
  bundlePackages = bundlePackages?.filter(
    (item) => item.ln_sl_lexis_ai_package !== 1
  );

  const features = useAppSelector(selectFeaturesSelector);
  const featureType = useAppSelector(selectFeatureTypeSelector);

  useEffect(() => {
    let temploading = { ...loading };
    featuresService.setCompareFeatureType(setFeatureType, async (res: any) => {
      temploading.featureType = false;
      setLoading(temploading);
      if (res.length > 0) {
        const contentTypeId: Array<Number> = [];
        res.map((item: FeatureTypeState) =>
          contentTypeId.push(item.content_type_id)
        );
        await featuresService.setCompareFeatures(
          contentTypeId,
          setFeatures,
          () => {
            temploading.features = false;
            setLoading(temploading);
          }
        );
      }
    });
  }, []);

  const setProducts = () => {
    const items = [] as any;
    bundlePackages.map((item: ItemState) =>
      items.push({
        sku: item.sku,
        name: item.name,
        mvp: item.ln_sl_is_most_popular,
        id: item.id,
      })
    );
    return items;
  };

  const mapBundleToFeature = (bundles: string) => {
    let arr = Array<boolean>();
    bundlePackages.map((item: ItemState) =>
      arr.push(bundles.includes(item.sku))
    );
    return arr;
  };

  const setTableData = () => {
    let data = [] as any;
    featureType.map((item: FeatureTypeState) => {
      let obj = {
        content_type: item.content_type,
        features: [] as any,
        content_id: item.content_type_id,
      };
      features.map((feature: FeatureState) => {
        if (item.content_type_id === feature.content_type) {
          let featureObj = {
            feature_id: feature.feature_id,
            feature_name: feature.feature_name,
            feature_description: feature.feature_description,
            applicable_to: mapBundleToFeature(feature.applicable_to),
          };
          obj.features.push(featureObj);
        }
      });
      data.push(obj);
    });
    return data;
  };

  return (
    <section className="bg-grey-scale-grey-50 py-6 md:mt-16 mb-12 px-2 md:px-16 flex flex-col items-center">
      {!(loading.features && loading.featureType) ? (
        <>
          <h2 className="text-2xl text-center font-bold md:text-5xl  md:font-black md:py-10">
            {title}
          </h2>
          <ComparisionTable
            products={setProducts()}
            tableData={setTableData()}
            openDialog={openDialog}
            mvpTitle={constants.mvpTitle}
            isSelected={isSelected}
          />
        </>
      ) : (
        <ComparisionTableLoader />
      )}
    </section>
  );
};
export default ComparisionTableLayout;
